import { Modal, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import './styles.css';

interface ShowModalProps {
    show: boolean,
    itemName: string
    toggleShow: () => void,
    setResponse: (resp: boolean) => void
}

const ModalDelete = ({ show, toggleShow, setResponse, itemName }: ShowModalProps) => {
    const handleClose = () => {
        setResponse(false);
        toggleShow();
    }
    const handleConfirm = () => {
        setResponse(true);
        toggleShow();
    }

    return (
        <Modal
            title="Excluir"
            onCancel={handleClose}
            open={show}
            footer={null}
            centered
            closable={true}
            className='modal-container'
        >
            <div className='d-flex align-items-center justify-content-center'>
                <DeleteOutlined className='delete-btn-icon' />
            </div>
            <p className='p-text'>
                Deseja deletar o {itemName}?
            </p>
            <div className='btns-delete-modal'>
                <Button
                    type='default'
                    onClick={handleClose}
                    className='btn-modal-cancel'
                >
                    Cancelar
                </Button>
                <Button
                    type='primary'
                    className='btn-modal-delete'
                    danger
                    onClick={handleConfirm}
                >
                    Confirmar
                </Button>
            </div>
        </Modal>
    );
};

export default ModalDelete;